<script>
import axios from 'axios';
import Paginator from '@/components/datatables/Paginator.vue';
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import { downloadFile } from '@/utils/fileDownloader';

export default {
  components: {
    Paginator
  },
  props: {
    filterDate: {
      type: String,
      default: ''
    },
    TableType: {
      types: String,    
    }
  },
  data() {
    return {
      result: [],
      loadingDetailSubmission: false,
      detailSubmission: {},
      CompletedCountCountNo: 0,
      FailedCountNo: 0,
      waitingCountNo: 0,
      totalSubmission: 0,
    };
  },
  methods: {
    getlist(page = 1) {
      this.result = [];
      this.loadingDetailSubmission = true;

      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');

      axios.get(process.env.VUE_APP_AR_API_BASEURL + this.TableType + '/submissions', {
        params: {
          page: page,
          filterDate: this.filterDate
        }
      })
      .then(response => {
        if (response) {
          this.result = response.data;

          // ✅ Emit search-complete with hasData flag
          const hasData = Array.isArray(response.data?.data) && response.data.data.length == 0;
          this.$emit('search-complete', hasData);
        }
      })
      .finally(() => {
        this.loadingDetailSubmission = false;
      });
    },
    exportSubmission(jobid) {
      downloadFile(
          process.env.VUE_APP_AR_API_BASEURL + this.TableType +'/export/submission' + jobid,
          'recollect job Id '+ jobid + '.xlsx'
      );
    },

    Detail(id) {
      this.loadingDetailSubmission = true;
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_AR_API_BASEURL + this.TableType + '/submissions/' + id)
        .then(response => {
          if (response) {
            this.detailSubmission = response.data;
            this.waitingCount();
            this.CompletedCount();
            this.FailedCount();
            this.totalSubmission = this.detailSubmission.repayments.length;
          }
        })
        .finally(() => {
          this.loadingDetailSubmission = false;
        });
    },
    waitingCount() {
      this.waitingCountNo = this.detailSubmission.repayments.filter(
        r => r.status === 'WAITING_FOR_BANK_PROCESSING' || r.status === 'NEW'
      ).length;
    },
    CompletedCount() {
      this.CompletedCountCountNo = this.detailSubmission.repayments.filter(
        r => r.status === 'Successfully Complete'
      ).length;
    },
    FailedCount() {
      this.FailedCountNo = this.detailSubmission.repayments.filter(
        r => r.status === 'FAILED'
      ).length;
    }
  },
  mounted() {
    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
    this.getlist();
  }
};
</script>


<template>
    <div>
        <div class="table-responsive mt-3">
            <table class="table table-striped table-nowrap mb-0">
                <thead class="table-secondary">
                    <tr>
                        <th>No.</th>
                        <th>Batch ID</th>
                        <th>Submission ID</th>
                        <th>Submission Date</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in result.data" :key="index" class="content">
                        <td>{{ index + result.from }}</td>
                        <td>{{ item.batch_id }}</td>
                        <td>{{ item.job_id }}</td>
                        <td>{{ item.created_at ?? 'N/A' }}</td>
                        <td>{{ item.status }}</td>
                        <td>
                            <div class="d-flex align-items-center gap-2">
                                <span
                                @click="Detail(item.id)"
                                class="p-0"
                                data-bs-toggle="modal"
                                data-bs-target=".bs-example-modal-lg"
                                style="cursor: pointer;"
                                >
                                <i class="ri-eye-fill align-bottom text-muted"></i>
                                </span>
                            </div>
                        </td>

                    </tr>
                    </tbody>
            </table>
            <div class="mt-4" style="display: flex; justify-content: space-between; align-items: center;">
                <div>Showing {{ result.from }} to {{ result.to }} of {{ result.total }} results</div>
                <Paginator :data="result" :limit="1" @pagination-change-page="getlist"></Paginator>
            </div>
        </div>
    </div>

    <div class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myLargeModalLabel">Collection submmission</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close">
                    </button>
                </div>
                <div class="modal-body"> 
                    <div class="card-body">
                        <div v-if="loadingDetailSubmission">
                            <div class="spinner-border text-success" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-lg-12">
                                <p class="text-muted mb-0">
                                  <strong>ReCollect Submission Result</strong><br>
                                  <strong>Batch ID:</strong> {{ detailSubmission.batch_id }}<br>
                                  <strong>Submission ID:</strong> {{ detailSubmission.job_id }}<br>
                                  <br>
                                </p>
                                <table class="table table-bordered table-striped table-nowrap mb-0 table-sm">
                                    <thead class="table-secondary" >
                                        <tr>
                                            <th>Total Collection Send</th>
                                            <th>Total Success</th>
                                            <th>Total Waiting</th>
                                            <th>Total Fail</th>
                                        </tr>
                                    </thead>
                                    <tr>
                                        <td>{{ totalSubmission }}</td>
                                        <td>{{ CompletedCountCountNo }}</td>
                                        <td>{{ waitingCountNo }}</td>
                                        <td>{{ FailedCountNo }}</td>
                                    </tr>
                                </table>
                                <br>
                                <div class="table-responsive mt-3">
                                  <table class="table table-bordered table-striped table-nowrap mb-0 table-sm">
                                      <thead class="table-secondary" >
                                          <tr>
                                              <th>Customer Name</th>
                                              <th>Ref. No</th>
                                              <th>Curlec Ref</th>
                                              <th>Amount</th>
                                              <th>Status</th>
                                          </tr>
                                      </thead>
                                      <tr v-for="(item, index) in detailSubmission.repayments" :key="index">
                                          <td>{{ item.customer.name_as_per_nric }}</td>
                                          <td>{{ item.invoice.invoice_no }}</td>
                                          <td>{{ item.mandate_ref }}</td>
                                          <td>RM {{ item.amount }}</td>
                                          <td>{{ item.status ==='FAILED' ? 'FAILED - '+ item.descriptions : item.status }}</td>
                                      </tr>
                                  </table>
                                </div>
                                <br>
                            </div>
                            
                        </div>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>